// extracted by mini-css-extract-plugin
module.exports = {"version-option":"BvAUVmlaT9KVlWmmpifQcA=="};